import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Typography,
  Box,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { getDiscourseByTitle ,searchDiscourse } from "../../../services/database/database_service";
import LoadingIndicator from "../components/LoadingIndicator";
import YouTubePlayer from "./YoutubePlayer";
import { useLanguage} from "../../../services/localization/LanguageContex";




function DiscourseSearchResult() {
  const {t } = useLanguage();
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const discourseTitle = queryParams.get("search_query");

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [discourseData, setDiscourseData] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    setSearchTerm("");
    async function fetchDiscourseData() {
      setLoading(true); // Reset loading for each new search
      try {
        const data = await getDiscourseByTitle(discourseTitle);
        if (data.documents) {
          setDiscourseData(data.documents[0]);
        }
      } catch (err) {
        setError(err.message);
        // console.log('Stamp: ',err);
      } finally {
        setLoading(false);
      }
    }
    // if (discourseTitle) fetchDiscourseData();
    fetchDiscourseData();
  }, [discourseTitle]);
  

  // Debounced search effect
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const doSearch = async () => {
        if (searchTerm.trim() === "") {
          setSearchResults([]);
          return;
        }
        setIsSearching(true);
        try {
          const res = await searchDiscourse(searchTerm);
          setSearchResults(res.documents);
          // console.log('result',res.documents);
        } catch (e) {
          setSearchResults([]);
          setError(e.message);
        } finally {
          setIsSearching(false);
        }
      };
      doSearch();
    }, 300);
  
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  return (
    <Box
      sx={{
        px: { xs: 3, sm: 6, md: 6 },
        pt: 2, pb:4
      }}
    >
      {/* 🔍 Search Bar */}
      <Box sx={{ maxWidth: 400, mx: "auto", 
        mb: 1, 
         position: "relative" }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder={t("Search discourse...")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        {/* 🔍 Search results dropdown */}
        {searchTerm && (
          <Box
            sx={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              bgcolor: "background.paper",
              boxShadow: 3,
              zIndex: 10,
              maxHeight: 300,
              overflowY: "auto",
              borderRadius: 1,
              mt: 1,
            }}
          >
            {isSearching ? (
              <Typography sx={{ p: 2 }} align="center">
                {t("Searching...")}...
              </Typography>
            ) : searchResults.length === 0 ? (
              <Typography sx={{ p: 2 }} align="center">
                {t("No results found")}
              </Typography>
            ) : searchResults.map((result) => (
                <Box
                  key={result.$id}
                  onClick={() => {
                    navigate(`/home/discourse/result?search_query=${encodeURIComponent(result.discourseTitle)}`);
                  }}
                  sx={{
                    p: 2,
                    "&:hover": { bgcolor: "grey.100", cursor: "pointer" },
                  }}
                >
                  <Typography variant="subtitle2">{result.discourseTitle}</Typography>
          
                </Box>
              ))}
          </Box>
        )}
      </Box>

      <Typography
        variant="h4"
        gutterBottom
        align="center"
        // style={{ marginBottom: 15 }}

        sx={{
              fontSize: { xs: "1.5rem", sm: "1.7rem", md: "2rem" }, mt:1
        }}
      >
        {t(discourseTitle)}
      </Typography>

      <Box
             sx={{
               mx: "auto",
               maxWidth: 900,
               backgroundColor: "white", // background color for the card
             }}
           >
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <LoadingIndicator />
          </Box>
        ) : error? (
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Typography variant="h6" color="error">
              {error}
            </Typography>
          </Box>
        ) : !discourseData || Object.keys(discourseData).length === 0 ?
        
        (
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Typography variant="h6" color="textSecondary" gutterBottom>
              Discourse not found.
            </Typography>
            <Typography variant="body1" color="textSecondary">
              Please check back later.
            </Typography>
          </Box>
        ) : (
          <>
          <YouTubePlayer url={discourseData.discourseUrl} />
          <Typography variant="body1" align="center" sx={{ mt: 2 }}>
            {t(discourseData.discourseDescription)}
          </Typography>
        </>
        )}
      </Box>
    </Box>
  );
}

export default DiscourseSearchResult;
